import React from 'react';

function OrderFormField(props) { 

  function labelUrl(label, urlText, url) {
    let txt =
      label + " (<a target='_self' href='" + url + "'>" + urlText + "</a>)";
    return { __html: txt };
  }

  function composeLabel(labelTxt) {
    if (labelTxt.length === 0)
        return null;
    if (props.url && props.url.length > 0) {
      return (
        <label
          dangerouslySetInnerHTML={labelUrl(labelTxt, props.urlText, props.url)}
        />
      );
    } else return <label>{labelTxt}</label>;
  }

  let label = props.lbl;
  if (props.required === true && label.length > 0) label += " *";

  return (
    <div className={props.cssClass}>
      {props.labelRight === true ? null : composeLabel(label)}

      <p>{props.value}</p>

      {props.labelRight === true ? composeLabel(label) : null}
      {props.imgUrl && props.imgUrl.length > 0 ? (
        <img src={props.imgUrl} alt={props.imgAlt} title={props.imgAlt} />
      ) : null}

      {props.labelRight === true ? <div className="clear" /> : null}
    </div>
  );
}

export default OrderFormField;